export const spaTexts = {
	knowMore: 'Saber más',
	ngoPurpose:
		'La captación de fondos para proyectos de la ONG, mantenerle informado sobre la ONG y la evolución del proyecto para el que ha donado fondos y la emisión de certificados de desgravación fiscal.',
	termsPurpose:
		'Gestionar la relación negocial en todos sus ámbitos, así como su donación y su solicitud de certificado, y el envío de comunicaciones comerciales por vía electrónica.',
	termsRights:
		'Tiene derecho a acceder, rectificar y suprimir los datos, así como otros derechos, como se explica en la información adicional.',
	termsAdditionalInfo:
		'Puedes consultar información adicional y detallada sobre Protección de datos en nuestra página <a href="https://www.worldcoo.com/gdpr">web</a> o bien contactando en <a href="mailto:rgpd@worldcoo.com">rgpd@worldcoo.com</a>.',
	termsRecipients:
		'No se cederán datos a terceros, excepto a los encargados de tratamiento fuera de la UE, acogidos a Privacy Shield.',
	unexpectedError: 'Hubo un error inesperado',
	amountError: 'La cantidad de dinero no era válida',
	authError: 'Hubo un error al autorizar el pago',
	cardError: 'Hubo un error con la tarjeta',
	referralError: 'Hubo un error de referencia',
	transactionError: 'Hubo un error en la transacción',
	FundedByEmployees: `Financiada a través de los empleados/as`,
	resetFilters: 'Borrar filtros',
	category: 'Causa',
	basicNeeds: 'Necesidades básicas',
	humanRights: 'Derechos humanos',
	education: 'Educación',
	emergency: 'Emergencia',
	feeding: 'Alimentación',
	environment: 'Medio ambiente',
	habitat: 'Habitat',
	health: 'Salud',
	clear: 'Limpiar',
	active: 'Activo',
	finished: 'Terminado',
	status: 'Estado',
	filters: 'Filtros',
	year: 'Año',
	dedicateToTemplate:
		'¡Hola! Recibes este correo porqué {{donorName}} te ha dedicado una donación de {{amount}} {{currency}} para la ONG {{ngoName}} en la campaña {{campaignName}}. Esta donación te la ha dedicado a ti con la intención de hacer del mundo un lugar un poco mejor',
	dedicateToTemplateTitle: 'El mensaje de tu dedicatória',
	dedicateToWarning:
		'Este mensaje se enviará al destinatario del correo electrónico proporcionada anteriormente. Confirmo que he solicitado permiso al destinatario para enviar este mensaje',
	dedicateToRecipientEmail: 'Email del destinatario',
	dedicateToRecipientName: 'Nombre del destinatario',
	dedicateDonationTitle: 'Quiero dedicar mi donación a alguien',
	dedicateDonationMessage: 'Me gustaría dedicar mi donación a alguien',
	responsable: 'Responsable',
	telefonicaTermsAndConditionsLink: 'los términos del Aviso Legal de la Fundación Telefónica',
	purpose: 'Finalidad',
	legitimation: 'Legitimación',
	recipients: 'Destinatarios',
	rights: 'Derechos',
	ngoAdditionalInfoTitle: 'Información adicional',
	id: 'NIF / NIE',
	taxId: 'CIF',
	passport: 'Pasaporte',
	others: 'Otros',
	aCampaignBy: 'Una campaña de',
	campaignAudited: 'Campaña auditada por',
	termsAndCons: 'términos de Protección de Datos de Worldcoo',
	ngoTerms: 'términos de Protección de Datos de',
	haveReadAndAccept: 'He leído, entiendo y acepto los',
	termsButton: 'He leido, acepto y entiendo',
	acceptNgoTermsLink: 'términos de Protección de {{ngo}}',
	acceptRecurrentTermsLink:
		'He leído, entiendo y acepto los <a class="terms_button" data-open-modal="recurrentTerms" data-modal-classes="terms-modal full-scroll" href="#">términos de Protección de Datos de las ONGs</a>',
	activities: 'Actividades',
	additionalInfo: 'Información adicional',
	anyComments: '¿Quieres hacer algún comentario?',
	businessName: 'Razón social',
	campaignObjectives: 'Objetivos de la campaña',
	campaignFunded: '¡Campaña financiada!',
	campaigns: 'Campañas',
	cancel: 'Cancelar',
	cardBrandNotAccepted: 'No se acepta este tipo de tarjetas.',
	cardRegisteredSuccessfully: 'La tarjeta se ha registrado con éxito',
	cardsSupported: 'Tarjetas soportadas:',
	certificateOnlyValidInExpeditionCountry:
		'El certificado de donación solo tendrá validez en el país de origen donde esté inscrita la entidad beneficiaria de los donativos.',
	certificateNeededData: 'Datos necesarios para obtener el certificado de donación:',
	change: 'Cambiar',
	checkoutSuccess: 'Tu donación se ha realizado correctamente, gracias por participar.',
	city: 'Ciudad',
	collectedFundsDistribution: 'Los fondos recaudados se repartirán equitativamente entre los siguientes proyectos:',
	comments: 'Comentarios',
	company: 'Empresa',
	confirm: 'Confirmar',
	contactData: 'Datos de contacto',
	cookiesMessage: 'Este sitio utiliza cookies. Si continua navegando consideramos que acepta su uso.',
	country: 'País',
	creditCard: 'Tarjeta de crédito',
	dataReceivedSuccessfully: 'Hemos recibido correctamente tus datos.',
	description: 'Descripción',
	directBeneficiaries: 'Beneficiarios directos',
	directBeneficiariesDescription:
		'Aquellas personas que de forma natural han sido beneficiadas por las acciones desarrolladas en la campaña.',
	documentNumber: 'Nº de documento',
	documentType: 'Tipo de documento',
	donationAmount: 'Importe de donación',
	donationAmountError: 'El importe de donación no es correcto',
	donationAmountMinimumIs: 'El importe mínimo es de {{amount}}',
	donationCertificate: 'Certificado de donación',
	donations: 'Donaciones',
	donors: 'Donaciones',
	donated: 'Donados',
	donatedOf: 'Donados de',
	donateMonthly: 'Donar mensualmente',
	donationOnBehalf: 'Hacer donación en nombre de',
	door: 'Puerta',
	email: 'Correo electrónico',
	fillFollowingFields: 'Rellene los siguientes campos',
	finish: 'Finalizar',
	floor: 'Piso',
	funded: 'Financiado',
	genericCardError: 'Ha habido algún error con tu tarjeta.',
	goBack: 'Volver',
	identityDocument: 'Documento de identidad',
	indicateDataToIdentify: 'Indícanos estos datos para que podamos identificarte:',
	indirectBeneficiaries: 'Beneficiarios indirectos',
	indirectBeneficiariesDescription:
		'Aquellas personas identificables que reciben un efecto potencial de las acciones desarrolladas en la campaña.',
	inDoubtContactHere: 'Cualquier duda que tengas puedes contactarnos aquí:',
	informYouViaMail: 'Te informaremos en detalle por correo electrónico.',
	makeDonation: 'Hacer donación',
	makeOneTimeDonation: 'Hacer donación puntual',
	makeYourDonation: 'Haz tu donación',
	manageMyDonations: 'Gestionar mis donaciones',
	manyThanks: '¡Muchas gracias!',
	modifyAmount: 'Modificar el importe de donación',
	modifyRecurrentDonationSuccess:
		'<p class="margin-top-40">Hemos recibido tu solicitud correctamente.</p><p>En unos dias te enviaremos un email confirmando que hemos realizado los cambios que nos has pedido.</p><p>Si tienes alguna duda puedes contactarnos aqui:</p><p class="margin-top-20"><strong><a href="mailto:contact@worldcoo.com">contact@worldcoo.com</a></strong></p>',
	modifyRecurrentDonationTitle: 'Si ya eres donante, aquí puedes modificar o cancelar tu donación:',
	moreInfo: 'Más información',
	name: 'Nombre',
	next: 'Siguiente',
	otherAmount: 'Otra cantidad',
	overlayError:
		'<p>Se ha producido un error</p><p>Por favor, vuelve a intentarlo más tarde o ponte en contacto con nosotros aquí:</p><p><strong>contact@worldcoo.com</strong></p>',
	particular: 'Particular',
	paymentData: 'Datos de pago',
	paymentType: 'Forma de pago',
	personalData: 'Datos personales',
	pleaseFillFields: 'Por favor, rellene los siguientes datos:',
	postalCode: 'Código postal',
	province: 'Provincia',
	raised: 'Recaudados',
	raisedTillNow: 'Recaudado hasta ahora:',
	recurrentFormError:
		'Ha ocurrido algún error procesando tu solicitud. Por favor, inténtalo más tarde o contáctanos aquí:',
	region: 'Región',
	repeatEmail: 'Repetir correo electrónico',
	repsolEmployeesPortal: 'Portal solidario de empleados',
	seeCampaigns: 'Ver campañas',
	send: 'Enviar',
	share: 'Compartir',
	sorry: '¡Lo sentimos!',
	stairNumber: 'Escalera',
	stopMakingDonation: 'Dejar de donar mensualmente',
	step1: 'Paso 1',
	step2: 'Paso 2',
	step3: 'Paso 3',
	step4: 'Paso 4',
	streetName: 'Nombre de la vía',
	streetNumber: 'Num.',
	streetType: 'Tipo de vía',
	summary: 'Resumen',
	surname: 'Apellidos',
	telefonicaUseCorporateMail:
		'* Si eres empleado de Telefónica en activo utiliza preferiblemente tu correo electrónico corporativo.',
	thanks: '¡Gracias!',
	typeTheAmount: 'Teclea el importe',
	unavailableLanguageMessage:
		'No disponemos del contenido de esta campaña en español. Trabajamos constantemente para proporcionar más contenido en su idioma. Gracias por su paciencia.',
	updatesAndLinks: 'Actualizaciones y enlaces',
	validationEqualFields: 'Los campos {{label}} y {{fieldName}} no son iguales',
	validationIsRequired: 'El campo {{label}} es obligatorio',
	validationValidEmail: 'El campo {{label}} no es un email válido',
	viewCampaignInfo: 'Ver información de la campaña',
	viewInfo: 'Ver información',
	wantCertificate: 'Quiero un certificado de donación',
	wantWorldcooNewsletter: 'Deseo recibir información de Worldcoo',
	whatIsNewAmount: 'Dinos cuál es el nuevo importe que quieres donar (en {{currency}}):',
	whatYouWantToDo: '¿Qué quieres hacer?',
	whoWillBenefit: '¿Quién se beneficiará?',
	youCanAlsoDonateOneTime: 'También puedes hacer una donación puntual accediendo a cualquiera de ellos.',
	yourDonationWillBeCharged: 'Tu donación se cargará el día 15 de cada mes.',
	yourRequestIsProcessing: 'Tu solicitud se está procesando. Espera unos segundos, por favor.',
	youSureCancelRecurrentDonation: '¿Confirmas que quieres dejar de hacer una donación mensual?',
	ngoTermsTitle: 'Información básica sobre Protección de Datos',
	ngoLegitimation: 'La base legal para el tratamiento de sus datos es la obtención de su consentimiento.',
	ngoRecipients: 'No se cederán datos a terceros salvo que exista obligación legal para ello.',
	ngoAdditionalInfoEmail:
		'Puede consultar la información adicional y detallada sobre Protección de Datos en la web de cada ONG.',
	amountMustBeGreaterThanZero: 'La cantidad debe ser mayor de 0',
	amountMustBeLowerThan3000: 'La cantidad debe ser menor de 3000',
	metafieldsNoTicket: 'Fila 0. Donación sin entrada',
	metafieldsTickets:
		'¿Cuántas invitaciones necesitas para el concierto? Ten en cuenta que por cada 10€ donados consigues una invitación.',
};
